import Task from "./task";

export default class Item {
  constructor(data) {
    Object.assign(this, data);
  }

  isOwnedBy(user) {
    if (this.user_id === undefined) {
      throw new Error("L'ajttribut user_id manque sur l'objet.");
    }

    if (!this.user_id) {
      // This item is not owned by anyone
      return false
    }

    return this.user_id === user.id;
  }

  getId() {
    return `${new Date(this.created_at).getFullYear()}-${String(
      this.count_in_year || this.id
    ).padStart(5, "0")}`;
  }

  getComments() {
    const comments = this.comments;
    comments.sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
    return comments;
  }

  getTasks() {
    const tasks = this.tasks;
    tasks.sort((a, b) => new Date(b.starts_at) - new Date(a.starts_at));
    return tasks.map(t => new Task(t));
  }

  getDriveFolderUrl() {
    if (!this.sharepoint_path) {
      return null;
    }

    const sitename = process.env.REACT_APP_SHAREPOINT_BASE_URL.split("/").at(-1)
    return `${process.env.REACT_APP_SHAREPOINT_BASE_URL}/Documents%20partages/Forms/AllItems.aspx?id=/sites/${sitename}/Documents partages/${this.sharepoint_path}`;
  }
}
